import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  checkIfDemoUserExist,
  demoLogin,
  forgotPassword,
  loginUser,
  resetPassword,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { APP_CONST } from "../../../config/const";

import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import BackArrow from "../../../assets/svg/back-arrow.svg";
import { useTranslation } from "react-i18next";
import Android from "../../../assets/images/icons/android-apk.webp";
import ArrowDown from "../../../assets/images/icons/arrow-down.webp";
import Facebook from "../../../assets/images/icons/social/facebook.svg";
import Instagram from "../../../assets/images/icons/social/Instagram.svg";
import Twitter from "../../../assets/images/icons/social/X.svg";
import Whatsapp from "../../../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../../../assets/images/icons/social/Telegram.svg";
import Animate1 from "../../../assets/images/icons/login-reg/volleyball.webp";
import Animate2 from "../../../assets/images/icons/login-reg/cricket.webp";
import Animate3 from "../../../assets/images/icons/login-reg/baseball.webp";
import LoginWithOtp from "./LoginWithOtp";

const LoginModal = ({ show, handleClose, handleModalShow }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [changeModalContent, setChangeModalContent] = useState(true);
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });
  const [modalState, setModalState] = useState("login");
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;
  const isOtpRequired = appDetails?.OTP === 0;
  const [checked, setChecked] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    checkDemoUser();
  }, []);

  const checkDemoUser = async () => {
    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };
  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = t("username_cannot_be_empty");
    }
    if (!password || password === "") {
      newErrors.password = t("password_cannot_be_empty");
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();
    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      let loginData = { ...formData };
      // handleClose();
      dispatch(loginUser(loginData));
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const handleSubmitForgotPass = async (e) => {
    e.preventDefault();

    let payload = {};
    if (email?.email || mobileNumber) {
      if (isEmailOtpRequired) {
        payload.email = email?.email;
      } else {
        const phoneNumber = parsePhoneNumber("+" + mobileNumber);

        payload.phone = phoneNumber.nationalNumber;
        payload.countryCode = phoneNumber.countryCallingCode;
      }
      forgotPassword(payload)
        .then((res) => {
          if (res.data.error === false) {
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("OTP_sent"));
            setIsOtpSent(true);
            // navigate("/reset-password");
            // handleClose();
            // handleModalShow(APP_CONST.AUTH_MODAL.RESET_PASSWORD);
          }
        })
        .catch((err) => {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
        });
    } else {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        isEmailOtpRequired
          ? t("please_enter_email")
          : t("please_enter_mobile_number"),
      );
    }
  };

  const handleSubmitResetPass = () => {
    setIsVerifying(true);

    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, t("all_fields_are_mandatory"));
    } else {
      const payload = {
        otp,
        password,
      };

      resetPassword(payload)
        .then((res) => {
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("password_reset_success"));
          // navigate("/sign-in");
          // handleClose();
          // handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
          setModalState("login");
        })
        .catch((err) => {
          Toaster(
            APP_CONST.TOAST_TYPE.ERROR,
            err.response.data.message || t("request_failed"),
          );
          setIsVerifying(false);
        });
    }
  };

  const handleDemoLogin = () => {
    dispatch(demoLogin());
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas lgn-reg-modal login"}
      onHide={() => {
        console.log("working");
      }}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        <div className="animation-login d-sm-none">
          <img src={Animate1} alt="Animate 1" className="img1" />
          <img src={Animate2} alt="Animate 2" className="img2" />
          <img src={Animate3} alt="Animate 3" className="img3" />
        </div>

        {modalState === "login" && (
          <div
            className={
              modalState != "login" ? `login-section` : `login-section active`
            }
          >
            <div className="Login-rightPart">
              <div className="inner-wrapper">
                <div className="right-content">
                  <h2 className="title">Log In</h2>

                  <div className="form-steps">
                    <Form>
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicName"
                      >
                        <Form.Control
                          type="text"
                          placeholder={"Email *"}
                          name="username"
                          onChange={handleChange}
                          isInvalid={!!errors.username}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.username}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder={t("password *")}
                          name="password"
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <span
                          className="icon"
                          onClick={() => setShowPassword((s) => !s)}
                        >
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                        <Form.Control.Feedback type="invalid">
                          {errors?.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="d-flex justify-content-between align-items-center my-4 d-none d-md-flex">
                        <Form.Check
                          type="checkbox"
                          label="Remember me"
                          checked={checked}
                          onChange={(e) => setChecked(e.target.checked)}
                        />

                        {/* {(isOtpRequired || isEmailOtpRequired) && (
                          <div className="frgt-pwd">
                            <a
                              onClick={() => {
                                setModalState("otp");
                              }}
                            >
                              {t("login_with_otp")}
                            </a>
                          </div>
                        )} */}
                      </div>
                      <Button
                        className="mt-4 mt-md-0"
                        variant="primary"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        {t("login")}
                      </Button>

                      {isDemoUserExist && (
                        <div className="demo-login mt-3">
                          <Button variant="primary" onClick={handleDemoLogin}>
                            Demo Login
                          </Button>
                        </div>
                      )}

                      {/* <div className="frgt-pwd mt-3 mb-1 my-sm-5 d-md-none">
                        <a
                          onClick={() => {
                            // handleClose();
                            // handleModalShow(APP_CONST.AUTH_MODAL.FORGOTO_PASSWORD);
                            setModalState("forgot")
                          }}
                        >
                          Forgot Your Password?
                        </a>
                      </div> */}
                      {/* <div className="frgt-pwd mt-3 mb-1 my-sm-5 d-md-none">
                        <a
                          onClick={() => {
                            // handleClose();
                            // handleModalShow(APP_CONST.AUTH_MODAL.FORGOTO_PASSWORD);
                             setModalState("otp");
                          }}
                        >
                           {t("login_with_otp")}
                        </a>
                      </div> */}
                    </Form>
                  </div>

                  <div className="login-via">
                    {/* <p>You can log in to your account via:</p> */}
                    <ul>
                      <li>
                        <a
                          href={
                            appDetails?.FACEBOOK != ""
                              ? appDetails?.FACEBOOK
                              : "#"
                          }
                          target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                        >
                          <img src={Facebook} alt="facebook" />
                          <span>Facebook</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={
                            appDetails?.INSTATGRAM != ""
                              ? appDetails?.INSTATGRAM
                              : "#"
                          }
                          target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                        >
                          <img src={Instagram} alt="instagram" />
                          <span>Instagram</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <img src={Twitter} alt="twitter" />
                          <span>Twitter</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={
                            appDetails?.WHATS_APP_URL != ""
                              ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                              : "#"
                          }
                          target={
                            appDetails?.WHATS_APP_URL != "" ? "_blank" : ""
                          }
                        >
                          <img src={Whatsapp} alt="whatsapp" />
                          <span>Whatsapp</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank">
                          <img src={Telegram} alt="telegram" />
                          <span>Telegram</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="account-signin-signup">
                  Don't have an account yet?&nbsp;
                  <br />
                  <div
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                      handleClose(APP_CONST.AUTH_MODAL.LOGIN);
                    }}
                  >
                    <p className="d-none d-sm-block">Registration</p>
                    <p className="d-sm-none">Register</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {modalState === "otp" && <LoginWithOtp setModalState={setModalState} />}
        {modalState === "forgot" && (
          <div
            className={
              modalState != "forgot"
                ? `login-section`
                : `login-section ForgotPasswordSection`
            }
          >
            <div className="Login-rightPart">
              <div className="inner-wrapper">
                <div className="right-content">
                  <div className="password-content">
                    <h2 className="title">Verify Number</h2>

                    <div className="form-steps">
                      <Form>
                        {!isEmailOtpRequired && (
                          <Form.Group
                            className="mb-4 position-relative"
                            controlId="formBasicPassword"
                          >
                            <PhoneInput
                              country={"tm"}
                              countryCodeEditable={false}
                              inputProps={{
                                name: "phone",
                              }}
                              // onlyCountries={["in"]}
                              inputStyle={{
                                width: "100%",
                              }}
                              onChange={(phone) => {
                                // alert("phone", phone);
                                // alert(phone);
                                setMobileNumber(phone);
                              }}
                            />
                          </Form.Group>
                        )}
                        {isEmailOtpRequired && (
                          <Form.Group
                            className="mb-3 position-relative"
                            controlId="formBasicPassword"
                          >
                            <Form.Control
                              type="email"
                              placeholder={t("enter_email *")}
                              value={email.email}
                              onChange={(e) =>
                                setEmail({ email: e.target.value })
                              }
                            />
                          </Form.Group>
                        )}
                        <Button
                          variant="primary mb-4"
                          type="submit"
                          onClick={handleSubmitForgotPass}
                        >
                          {t("get_OTP")}
                        </Button>

                        <Form.Group
                          className="mb-4 position-relative"
                          controlId=""
                        >
                          <Form.Control
                            type="text"
                            placeholder={t("enter_OTP *")}
                            onChange={(e) => setOtpValue(e.target.value)}
                            autoComplete="off"
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-4 position-relative"
                          controlId=""
                        >
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder={t("enter_new_password")}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                          />
                          <span
                            className="icon"
                            onClick={() => setShowPassword((s) => !s)}
                          >
                            {showPassword ? <FiEyeOff /> : <FiEye />}
                          </span>
                        </Form.Group>

                        <div className="sbmt-back">
                          <a
                            href="#"
                            className="back-btn"
                            onClick={() => setModalState("login")}
                          >
                            <img src={BackArrow} alt="back" />
                          </a>
                          <Button
                            variant="primary"
                            onClick={handleSubmitResetPass}
                            disabled={!isOtpSent}
                          >
                            {!isVerifying ? t("submit") : t("submitting")}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
